<template>
  <div class="in">
    <tips class="in-tip">
      <div class="in-tip__line"> 1. 当列表内的“FBA发补货计划单”显示对应的“发货单号”以及“备货完成状况”显示“已完成”，仓管员即可点击"发货单号" 查看发货单具体的发货内容，然后点击“直接创建发补货出仓单”完成操作； </div>
      <div class="in-tip__line"> 2. “发货单”由店管员进行物流预订后生成，仓管员只需要点击“发货单号”查看发货单发货内容及指示将货物交接给物流公司即可（但需要注意：“1个发货单”可能对应“多个FBA发补货计划单”，仓管员请根据发货单组织好货物交给物流公司） </div>
      <div class="in-tip__line"> 3. “发补货出仓单”由点击右侧的“查看/直接创建发补货出仓出仓单”直接创建；入仓分类为“仓库调拨”及“盘点调整”的出仓单由点击右上角的“创建其它出仓单”按钮创建；特别提示: 此处出仓的仓库为“国内中转仓”不包括FBA货物的"亚马逊仓库" </div>
    </tips>
    <div class="in-top">
      <div class="in-top__name">入仓登记</div>
      <div class="in-top__fun">
        <div class="in-top-item in-top-item--date">
          <div class="in-top-item__name">入仓日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="in-top-item">
          <div class="in-top-item__name">仓库分类:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="in-top-item">
          <div class="in-top-item__name">入仓单分类:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="in-top-item in-top-item--input">
          <el-input size="mini" placeholder="请输入货件追踪编号,FBA编号,仓库名称等"></el-input>
        </div>
        <div class="in-top__btn">搜索</div>
        <div class="in-top__btn">创建其他入仓单</div>
      </div>
    </div>
    <div class="in-table">
      <Table :head="TableHead" height="550" width="1654"></Table>
    </div>
  </div>
</template>

<script>
import { WarehouseAllocationNewModule, InLogSearchData } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'warehouseRegistration',
  components: {
    Table, tips
  },
  data(){
    return {
      searchData: new InLogSearchData(),
      TableHead: WarehouseAllocationNewModule.NEWINLOGTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.in{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 250px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
